export default __webpack_public_path__ + "static/media/11.831a9c1b.jpg";